import UppyBaseController from '../../../javascript/controllers/uppy_base_controller';
import { post } from '@rails/request.js'

import './styles.css'

export default class extends UppyBaseController {
  async uploadSuccess(file, response){
    const {
      meta: {
        signed_id,
      }
    } = file

    const formData = new FormData()
    formData.append(this.fieldNameValue, signed_id)

    await post(this.updateUrlValue, {
      body: formData,
      responseKind: 'turbo-stream',
    })
  }
}
